import {useMemo} from 'react';
import {useCustomer} from './api/metadata';
import {useScoringRunCounts} from './api/scoringRunCounts';
import {getLimit} from '../shared/customer';

export function useAccountLimitsForImport() {
  const customer = useCustomer();
  const {numActive} = useScoringRunCounts();

  return useMemo(() => {
    const activeAccountsLimit = getLimit(customer, 'activeAccounts');
    const currentActiveAccounts = numActive ?? 0;
    const isAtLimit = currentActiveAccounts >= activeAccountsLimit;

    return {
      isAtLimit,
      limitMessage: isAtLimit
        ? `You have reached your account limit of ${activeAccountsLimit.toLocaleString()} accounts. Please contact us for support.`
        : undefined,
    };
  }, [customer, numActive]);
}
